export default __webpack_public_path__ + "static/media/mascota2.0b74872b.jpg";